module.exports = __webpack_public_path__ + "img/kiosk-carrefour-estrie-search.2df6aa8d.jpg";